// ./src/contexts/PollQuestionsContext/PollQuestionsContext.tsx
//
// Thin context wrapper around the usePollQuestions hook. All derived data lives in
// the hook itself. See SignupItemsContext for the pattern.

import React, { createContext, useContext } from "react";

import {
  usePollQuestions,
  UsePollQuestionsOptions,
  UsePollQuestionsReturn,
} from "@/hooks/usePollQuestions";

const PollQuestionsContext = createContext<UsePollQuestionsReturn | null>(null);

export interface PollQuestionsProviderProps extends UsePollQuestionsOptions {
  children: React.ReactNode;
}

export const PollQuestionsProvider: React.FC<PollQuestionsProviderProps> = ({ children, ...options }) => {
  const value = usePollQuestions(options);

  return <PollQuestionsContext.Provider value={value}>{children}</PollQuestionsContext.Provider>;
};

export const usePollQuestionsContext = (): UsePollQuestionsReturn => {
  const context = useContext(PollQuestionsContext);

  if (!context) {
    throw new Error(
      "usePollQuestionsContext must be used within an <PollQuestionsProvider>. " +
        "Wrap your component tree with <PollQuestionsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalPollQuestionsContext = (): UsePollQuestionsReturn | null => {
  return useContext(PollQuestionsContext);
};
